import './News.css';
import NewsArticle from './NewsArticle';

function News() {

    const newsList = [
        {
            id: 0,
            date: 'April 29, 2024',
            title: 'Accidentally Finding The World\'s Best Cookies In Singapore',
            author: 'Medium',
            content: "So basically anyone can tell you that they found the best cookies in the world, but I've got to tell you, these cookies I stumbled upon in Singapore, on my recent 3-week trip to Asia are really next on the next level, and you wouldn't believe the name...",
            link: "https://medium.com/@tylertuccilloapple/accidentally-finding-the-worlds-best-cookies-in-singapore-f6e6cd42b230"
        },
        {
            id: 1,
            date: 'November 19, 2023',
            title: 'Coming All The Way From Beirut, The Barnyard Is The Newest Restaurant In Dubai; It Also Has A Library',
            author: 'Curly Tales',
            content: "For people who are always on the lookout for new places where they can enjoy a delicious meal with their friends, they'd certainly want to know about a new eatery that's open in Dubai. We are talking about The Barnyard, which is a pretty famous...",
            link: "https://curlytales.com/coming-all-the-way-from-beirut-the-barnyard-is-the-newest-restaurant-in-dubai-it-also-has-a-library/"
        },
        {
            id: 2,
            date: 'September 22, 2025',
            title: 'Upgrading software business models to thrive in the AI era',
            author: 'McKinsey & Company',
            content: "Roughly three years since gen AI emerged as the most disruptive force in enterprise software since the dawn of software-as-a-service (SaaS), companies are racing to launch agentic use cases and embed AI in every workflow. Whereas previous shifts...",
            link: "https://www.mckinsey.com/industries/technology-media-and-telecommunications/our-insights/upgrading-software-business-models-to-thrive-in-the-ai-era"
        },
        {
            id: 3,
            date: 'September 2015',
            title: 'Why People Thrive in Coworking Spaces',
            author: 'Harvard Business Review',
            content: "There seems to be something special about coworking spaces. As researchers who have, for years, studied how employees thrive, we were surprised to discover that people who belong to them report levels of thriving that approach an average of 6 on a 7-point...",
            link: "https://hbr.org/2015/05/why-people-thrive-in-coworking-spaces?utm_source=chatgpt.com"
        },
        {
            id: 5,
            date: 'March 16, 2026',
            title: 'Evidence-Based Nutraceuticals in Human Health and Longevity Medicine',
            author: 'Nutrients (MDPI)',
            content: "According to the World Health Organization (WHO), all countries face major challenges in adapting health and social systems to the rapid aging of the population, as the proportion of people over 60 is expected to nearly double from 12% to 22% between 2015 and 2050, and since the year 2020 older adults have already outnumbered children under 5 years globally. the rapid demographic shift toward an aging global population has intensified the need for developing effective strategies aimed not only at disease treatment, but at the preservation of functional capacity and quality of life across the...",
            link: "https://www.mdpi.com/2072-6643/18/6/935"
        }
    ]

  return (
    <div id="news">
        <div className="news-container">
            <h1>News & Articles</h1>
            <p className="news-subtitle">Our Highlights</p>
            <div className="news-articles">
                {
                    newsList.map(news => (
                        <NewsArticle key={news.id} date={news.date} title={news.title} author={news.author} content={news.content} link={news.link} />
                    ))
                }
            </div>
        </div>
    </div>
  );
}

export default News;
